export default "__VITE_ASSET__BydnuVKR__"